import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const SubheaderEmphasis = (props) => (
  <span {...props} className={cn(styles.subheaderEmphasis, props.className)} />
);

SubheaderEmphasis.propTypes = {
  className: PropTypes.string,
};

SubheaderEmphasis.defaultProps = {
  className: '',
};

export default SubheaderEmphasis;
